// src/components/Navbar.jsx — Shop World Classic Ecom Navbar
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { logoutUser } from '../firebase/services';

const SearchIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>);
const CartIcon  = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>);
const HeartIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>);
const UserIcon  = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>);
const MenuIcon  = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="3" y1="7" x2="21" y2="7"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="17" x2="21" y2="17"/></svg>);
const XIcon     = ({ s=20 }) => (<svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>);
const TrashIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);

const PRIMARY = '#E63946';
const DARK    = '#1C2B3A';
const GRAY    = '#6B7280';
const BORDER  = '#E5E7EB';
const BG_LIGHT= '#F9FAFB';
const WHITE   = '#FFFFFF';

export default function Navbar() {
  const { user, userData }    = useAuth();
  const { cart, totalItems, subtotal, removeFromCart, updateQty } = useCart();
  const navigate  = useNavigate();
  const location  = useLocation();
  const [cartOpen,     setCartOpen]     = useState(false);
  const [searchOpen,   setSearchOpen]   = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [mobileOpen,   setMobileOpen]   = useState(false);
  const [scrolled,     setScrolled]     = useState(false);
  const [q, setQ] = useState('');
  const inputRef   = useRef(null);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  useEffect(() => {
    setCartOpen(false); setUserMenuOpen(false); setMobileOpen(false);
  }, [location.pathname]);
  useEffect(() => {
    if (searchOpen) setTimeout(() => inputRef.current?.focus(), 80);
  }, [searchOpen]);
  useEffect(() => {
    const fn = () => { if (window.innerWidth > 900) setMobileOpen(false); };
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const navLinks = [
    { label: 'Home',    to: '/'                   },
    { label: 'Shop',    to: '/shop'               },
    { label: 'Offers',  to: '/shop?featured=true' },
    { label: 'Menu',    to: '/shop?type=food'     },
    { label: 'Vendors', to: '/shop?type=food'     },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');

        .sw-topbar {
          background: ${PRIMARY};
          color: #fff;
          font-size: 11px;
          font-weight: 600;
          text-align: center;
          padding: 6px 14px;
          font-family: 'Poppins', sans-serif;
          letter-spacing: 0.01em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .sw-topbar a { color: #fff; text-decoration: underline; margin-left: 4px; }

        .sw-nav {
          font-family: 'Poppins', sans-serif;
          background: ${WHITE};
          border-bottom: 1px solid ${BORDER};
          transition: box-shadow 0.3s;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 9999;
        }
        .sw-nav.scrolled { box-shadow: 0 2px 20px rgba(0,0,0,0.09); }

        .sw-nav-inner {
          max-width: 1280px; margin: 0 auto;
          height: 64px; padding: 0 24px;
          display: flex; align-items: center;
        }

        .sw-logo {
          display: flex; align-items: center; gap: 9px;
          text-decoration: none; flex-shrink: 0; margin-right: 40px;
        }
        .sw-logo-icon {
          width: 36px; height: 36px; border-radius: 8px;
          background: ${PRIMARY};
          display: flex; align-items: center; justify-content: center;
          font-size: 18px; box-shadow: 0 2px 8px rgba(230,57,70,0.3); flex-shrink: 0;
        }
        .sw-logo-text {
          font-size: 20px; font-weight: 800;
          color: ${DARK}; letter-spacing: -0.5px; white-space: nowrap; line-height: 1;
        }
        .sw-logo-text span { color: ${PRIMARY}; }

        .sw-desktop-links { display: flex; gap: 2px; flex: 1; align-items: center; }
        .sw-link {
          font-size: 13.5px; font-weight: 500; color: ${DARK}; text-decoration: none;
          padding: 7px 14px; border-radius: 7px; transition: all 0.18s; white-space: nowrap; position: relative;
        }
        .sw-link:hover { color: ${PRIMARY}; background: rgba(230,57,70,0.06); }
        .sw-link.act { color: ${PRIMARY}; font-weight: 700; background: rgba(230,57,70,0.06); }

        .sw-right { display: flex; align-items: center; gap: 2px; margin-left: auto; }
        .sw-icon-btn {
          background: none; border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          padding: 8px; border-radius: 8px; color: ${DARK}; position: relative;
          transition: color 0.18s, background 0.18s;
        }
        .sw-icon-btn:hover { color: ${PRIMARY}; background: rgba(230,57,70,0.07); }

        .sw-signin-btn {
          display: flex; align-items: center; gap: 7px;
          padding: 8px 18px; border-radius: 8px;
          font-size: 13px; font-weight: 600; color: ${DARK}; text-decoration: none;
          border: 1.5px solid ${BORDER}; background: ${WHITE};
          transition: all 0.2s; white-space: nowrap; margin-left: 6px;
          font-family: 'Poppins', sans-serif;
        }
        .sw-signin-btn:hover { border-color: ${PRIMARY}; color: ${PRIMARY}; background: rgba(230,57,70,0.04); }

        .sw-cart-badge {
          position: absolute; top: 2px; right: 2px;
          width: 15px; height: 15px; border-radius: 50%;
          background: ${PRIMARY}; color: #fff;
          font-size: 8px; font-weight: 700;
          display: flex; align-items: center; justify-content: center;
          border: 1.5px solid #fff; font-family: 'Poppins', sans-serif;
        }

        .sw-avatar {
          width: 32px; height: 32px; border-radius: 8px;
          background: rgba(230,57,70,0.1); border: 2px solid rgba(230,57,70,0.2);
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; font-weight: 700; color: ${PRIMARY};
        }

        .sw-user-menu {
          position: absolute; top: calc(100% + 8px); right: 0;
          background: ${WHITE}; border: 1px solid ${BORDER}; border-radius: 12px;
          min-width: 200px; overflow: hidden; box-shadow: 0 10px 40px rgba(0,0,0,0.12);
          animation: swScaleIn 0.15s ease; z-index: 999;
        }
        @keyframes swScaleIn { from{opacity:0;transform:scale(0.94) translateY(-4px)} to{opacity:1;transform:scale(1) translateY(0)} }
        .sw-drop-link {
          display: flex; align-items: center; gap: 9px;
          padding: 10px 16px; font-size: 13px; font-weight: 500;
          color: ${DARK}; text-decoration: none; border-bottom: 1px solid ${BORDER};
          transition: all 0.14s; font-family: 'Poppins', sans-serif;
        }
        .sw-drop-link:hover { background: ${BG_LIGHT}; color: ${PRIMARY}; }

        .sw-mobile-menu {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: ${WHITE}; z-index: 9998; overflow-y: auto;
          transform: translateX(-100%);
          transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
          padding-top: 60px;
          overscroll-behavior: contain;
        }
        .sw-mobile-menu.open { transform: translateX(0); }
        .sw-mobile-link {
          display: flex; align-items: center;
          padding: 15px 20px; font-size: 15px; font-weight: 500;
          color: ${DARK}; text-decoration: none; border-bottom: 1px solid ${BORDER};
          transition: all 0.14s; font-family: 'Poppins', sans-serif;
        }
        .sw-mobile-link:hover, .sw-mobile-link.act { color: ${PRIMARY}; background: rgba(230,57,70,0.04); padding-left: 26px; }

        .sw-overlay {
          position: fixed; inset: 0; z-index: 9997;
          background: rgba(0,0,0,0.45); animation: swFade 0.2s ease;
          backdrop-filter: blur(3px);
        }

        .sw-search-bar {
          position: fixed; top: 0; left: 0; right: 0; z-index: 10001;
          background: ${WHITE}; border-bottom: 2px solid ${PRIMARY};
          padding: 16px 24px; animation: swSlideDown 0.22s ease;
        }

        .sw-cart-drawer {
          position: fixed; right: 0; top: 0; height: 100%;
          width: 400px; max-width: 95vw;
          background: ${WHITE}; z-index: 10001;
          display: flex; flex-direction: column;
          box-shadow: -4px 0 30px rgba(0,0,0,0.12);
          animation: swSlideRight 0.28s ease;
        }
        .sw-qty-ctrl { display: flex; align-items: center; border: 1.5px solid ${BORDER}; border-radius: 7px; overflow: hidden; }
        .sw-qty-btn { width: 28px; height: 28px; background: none; border: none; cursor: pointer; font-size: 15px; font-weight: 700; color: ${DARK}; transition: background 0.15s; display:flex; align-items:center; justify-content:center; }
        .sw-qty-btn:hover { background: ${BG_LIGHT}; }
        .sw-qty-num { width: 28px; text-align: center; font-size: 13px; font-weight: 600; color: ${DARK}; font-family: 'Poppins', sans-serif; }

        @keyframes swFade       { from{opacity:0} to{opacity:1} }
        @keyframes swSlideDown  { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }
        @keyframes swSlideRight { from{transform:translateX(100%)} to{transform:translateX(0)} }

        @media(min-width: 901px) {
          .sw-hamburger { display: none !important; }
          .sw-mobile-menu { display: none !important; }
        }
        @media(max-width: 900px) {
          .sw-desktop-links { display: none !important; }
          .sw-desktop-signin { display: none !important; }
          .sw-topbar { display: none !important; }
          .sw-nav-inner { height: 60px; padding: 0 16px; }
          .sw-logo { margin-right: 0; }
        }
        @media(max-width: 480px) {
          .sw-cart-drawer { width: 100%; max-width: 100%; }
          .sw-logo-text { font-size: 17px; }
        }
        @media(max-width: 360px) {
          .sw-nav-inner { padding: 0 12px; }
          .sw-logo-text { font-size: 15px; }
          .sw-logo-icon { width: 28px; height: 28px; font-size: 14px; }
          .sw-icon-btn { padding: 6px; }
        }
      `}</style>

      {/* ─── TOPBAR ─── */}
      <div className="sw-topbar">
        🚚 Free delivery on orders over ₹499 —<a href="/shop">Shop Now</a>
      </div>

      {/* ─── NAVBAR ─── */}
      <nav className={`sw-nav${scrolled ? ' scrolled' : ''}`}>
        <div className="sw-nav-inner">

          {/* Logo */}
          <Link to="/" className="sw-logo">
            <div className="sw-logo-icon">🛍</div>
            <span className="sw-logo-text">Shop<span>World</span></span>
          </Link>

          {/* Desktop nav */}
          <div className="sw-desktop-links">
            {navLinks.map(l => (
              <Link key={l.label} to={l.to}
                className={`sw-link${location.pathname === l.to ? ' act' : ''}`}>
                {l.label}
              </Link>
            ))}
          </div>

          {/* Right actions */}
          <div className="sw-right">
            <button className="sw-icon-btn" onClick={() => setSearchOpen(true)} aria-label="Search">
              <SearchIcon />
            </button>

            {user && (
              <Link to="/wishlist" className="sw-icon-btn" style={{ textDecoration: 'none' }}>
                <HeartIcon />
              </Link>
            )}

            <button className="sw-icon-btn" onClick={() => setCartOpen(true)} aria-label="Cart">
              <CartIcon />
              {totalItems > 0 && <span className="sw-cart-badge">{totalItems > 9 ? '9+' : totalItems}</span>}
            </button>

            {user ? (
              <div style={{ position: 'relative' }}>
                <button className="sw-icon-btn" style={{ marginLeft: 2 }} onClick={() => setUserMenuOpen(!userMenuOpen)}>
                  <div className="sw-avatar">{(user.displayName || user.email || 'U')[0].toUpperCase()}</div>
                </button>
                {userMenuOpen && (
                  <div className="sw-user-menu">
                    <div style={{ padding: '12px 16px', borderBottom: `1px solid ${BORDER}`, background: BG_LIGHT }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: DARK, fontFamily: "'Poppins',sans-serif" }}>{user.displayName || 'Member'}</div>
                      <div style={{ fontSize: 11, color: GRAY, marginTop: 2, fontFamily: "'Poppins',sans-serif" }}>{user.email}</div>
                    </div>
                    {[
                      { to: '/account', label: '👤  My Account' },
                      { to: '/orders',  label: '📦  My Orders'  },
                      { to: '/wishlist',label: '❤️  Wishlist'   },
                      ...(userData?.role === 'admin' ? [{ to: '/admin', label: '⚙️  Admin' }] : []),
                    ].map(item => (
                      <Link key={item.to} to={item.to} className="sw-drop-link">{item.label}</Link>
                    ))}
                    <button onClick={() => { logoutUser(); navigate('/'); setUserMenuOpen(false); }} style={{
                      display: 'flex', alignItems: 'center', gap: 9, width: '100%',
                      padding: '10px 16px', fontSize: 13, fontWeight: 500, color: '#DC2626',
                      background: 'none', border: 'none', cursor: 'pointer',
                      fontFamily: "'Poppins',sans-serif", transition: 'background 0.14s', textAlign: 'left',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#FEF2F2'}
                    onMouseLeave={e => e.currentTarget.style.background = 'none'}
                    >🚪  Sign Out</button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="sw-signin-btn sw-desktop-signin">
                <UserIcon /> Sign in
              </Link>
            )}

            <button className="sw-hamburger sw-icon-btn" style={{ marginLeft: 4 }}
              onClick={() => setMobileOpen(v => !v)} aria-label="Menu">
              {mobileOpen ? <XIcon s={22} /> : <MenuIcon />}
            </button>
          </div>
        </div>
      </nav>

      {/* ─── MOBILE MENU ─── */}
      <div className={`sw-mobile-menu${mobileOpen ? ' open' : ''}`}>
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, height: 60,
          background: WHITE, borderBottom: `1px solid ${BORDER}`,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 16px', zIndex: 10,
        }}>
          <Link to="/" className="sw-logo" style={{ marginRight: 0 }} onClick={() => setMobileOpen(false)}>
            <div className="sw-logo-icon" style={{ width: 30, height: 30, fontSize: 15 }}>🛍</div>
            <span className="sw-logo-text" style={{ fontSize: 17 }}>Shop<span>World</span></span>
          </Link>
          <button onClick={() => setMobileOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: GRAY, padding: 6, display: 'flex' }}>
            <XIcon s={22} />
          </button>
        </div>

        <div style={{ padding: '12px 16px', borderBottom: `1px solid ${BORDER}`, background: BG_LIGHT }}>
          <form onSubmit={e => { e.preventDefault(); if (q.trim()) { navigate(`/shop?search=${encodeURIComponent(q.trim())}`); setMobileOpen(false); setQ(''); }}}
            style={{ display: 'flex', gap: 8, alignItems: 'center', background: WHITE, border: `1.5px solid ${BORDER}`, borderRadius: 9, padding: '9px 12px', width: '100%', boxSizing: 'border-box' }}>
            <SearchIcon />
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search products..."
              style={{ flex: 1, border: 'none', background: 'none', fontSize: 14, fontFamily: "'Poppins',sans-serif", color: DARK, outline: 'none' }} />
          </form>
        </div>

        {navLinks.map(l => (
          <Link key={l.label} to={l.to}
            className={`sw-mobile-link${location.pathname === l.to ? ' act' : ''}`}
            onClick={() => setMobileOpen(false)}>
            {l.label}
          </Link>
        ))}

        <div style={{ padding: '16px', borderTop: `1px solid ${BORDER}`, marginTop: 8 }}>
          {user ? (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 11, marginBottom: 14, padding: '12px 14px', background: BG_LIGHT, borderRadius: 10, border: `1px solid ${BORDER}` }}>
                <div style={{ width: 38, height: 38, borderRadius: 9, background: 'rgba(230,57,70,0.1)', border: '2px solid rgba(230,57,70,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 700, color: PRIMARY, flexShrink: 0, fontFamily: "'Poppins',sans-serif" }}>
                  {(user.displayName || user.email || 'U')[0].toUpperCase()}
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: DARK, fontFamily: "'Poppins',sans-serif" }}>{user.displayName || 'Member'}</div>
                  <div style={{ fontSize: 11, color: GRAY, fontFamily: "'Poppins',sans-serif" }}>{user.email}</div>
                </div>
              </div>
              {[{to:'/account',l:'My Account'},{to:'/orders',l:'My Orders'},{to:'/wishlist',l:'Wishlist'}].map(item => (
                <Link key={item.to} to={item.to} onClick={() => setMobileOpen(false)}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '11px 0', fontSize: 14, fontWeight: 500, color: DARK, textDecoration: 'none', borderBottom: `1px solid ${BORDER}`, fontFamily: "'Poppins',sans-serif" }}>
                  {item.l} <span style={{ color: '#C4C9D4' }}>›</span>
                </Link>
              ))}
              <button onClick={() => { logoutUser(); navigate('/'); setMobileOpen(false); }}
                style={{ marginTop: 14, width: '100%', padding: '12px', background: '#FEF2F2', color: '#DC2626', border: '1.5px solid #FCA5A5', borderRadius: 9, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: "'Poppins',sans-serif" }}>
                Sign Out
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link to="/login" onClick={() => setMobileOpen(false)}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '13px', background: PRIMARY, color: '#fff', borderRadius: 9, fontSize: 14, fontWeight: 700, textDecoration: 'none', fontFamily: "'Poppins',sans-serif", boxShadow: '0 4px 14px rgba(230,57,70,0.3)' }}>
                Sign In
              </Link>
              <Link to="/register" onClick={() => setMobileOpen(false)}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px', background: WHITE, color: DARK, borderRadius: 9, fontSize: 14, fontWeight: 600, textDecoration: 'none', border: `1.5px solid ${BORDER}`, fontFamily: "'Poppins',sans-serif" }}>
                Create Account
              </Link>
            </div>
          )}
        </div>
      </div>
      {mobileOpen && <div className="sw-overlay" style={{ zIndex: 9996 }} onClick={() => setMobileOpen(false)} />}

      {/* ─── SEARCH ─── */}
      {searchOpen && (
        <>
          <div className="sw-overlay" style={{ zIndex: 10000 }} onClick={() => setSearchOpen(false)} />
          <div className="sw-search-bar">
            <form onSubmit={e => { e.preventDefault(); if (q.trim()) { navigate(`/shop?search=${encodeURIComponent(q.trim())}`); setSearchOpen(false); setQ(''); }}}
              style={{ maxWidth: 680, margin: '0 auto', display: 'flex', gap: 12, alignItems: 'center' }}>
              <div style={{ color: PRIMARY, display: 'flex', flexShrink: 0 }}><SearchIcon /></div>
              <input ref={inputRef} value={q} onChange={e => setQ(e.target.value)}
                placeholder="Search products, restaurants..."
                style={{ flex: 1, background: 'none', border: 'none', color: DARK, fontSize: 17, fontFamily: "'Poppins',sans-serif", outline: 'none', padding: '4px 0', minWidth: 0 }} />
              <button type="button" onClick={() => setSearchOpen(false)}
                style={{ background: 'none', border: 'none', color: '#C4C9D4', cursor: 'pointer', display: 'flex', flexShrink: 0 }}><XIcon s={22} /></button>
            </form>
          </div>
        </>
      )}

      {/* ─── CART DRAWER ─── */}
      {cartOpen && (
        <>
          <div className="sw-overlay" onClick={() => setCartOpen(false)} />
          <div className="sw-cart-drawer">
            <div style={{ padding: '18px 20px', background: WHITE, borderBottom: `1px solid ${BORDER}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
              <h3 style={{ fontSize: 17, fontWeight: 700, color: DARK, margin: 0, fontFamily: "'Poppins',sans-serif" }}>
                Cart {totalItems > 0 && <span style={{ fontSize: 13, color: GRAY, fontWeight: 400 }}>({totalItems} items)</span>}
              </h3>
              <button onClick={() => setCartOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: GRAY, display: 'flex', padding: 6, borderRadius: 7, transition: 'background 0.15s' }}
                onMouseEnter={e => e.currentTarget.style.background = BG_LIGHT} onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                <XIcon s={20} />
              </button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>
              {cart.length === 0 ? (
                <div style={{ textAlign: 'center', paddingTop: 70 }}>
                  <div style={{ fontSize: 52, marginBottom: 14 }}>🛒</div>
                  <p style={{ color: GRAY, fontSize: 14, fontWeight: 500, fontFamily: "'Poppins',sans-serif", marginBottom: 18 }}>Your cart is empty</p>
                  <button onClick={() => { setCartOpen(false); navigate('/shop'); }}
                    style={{ padding: '10px 26px', background: PRIMARY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: "'Poppins',sans-serif" }}>
                    Start Shopping
                  </button>
                </div>
              ) : cart.map(item => (
                <div key={item._key} style={{ display: 'flex', gap: 13, marginBottom: 14, paddingBottom: 14, borderBottom: `1px solid ${BORDER}` }}>
                  <div style={{ width: 64, height: 64, borderRadius: 10, overflow: 'hidden', background: BG_LIGHT, flexShrink: 0 }}>
                    {item.image ? <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>🍽</div>}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: DARK, marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: "'Poppins',sans-serif" }}>{item.name}</div>
                    <div style={{ fontSize: 12, color: GRAY, marginBottom: 8, fontFamily: "'Poppins',sans-serif" }}>₹{item.price.toFixed(2)} each</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                      <div className="sw-qty-ctrl">
                        <button className="sw-qty-btn" onClick={() => item.qty === 1 ? removeFromCart(item._key) : updateQty(item._key, item.qty - 1)}>−</button>
                        <span className="sw-qty-num">{item.qty}</span>
                        <button className="sw-qty-btn" style={{ background: BG_LIGHT }} onClick={() => updateQty(item._key, item.qty + 1)}>+</button>
                      </div>
                      <span style={{ fontSize: 14, fontWeight: 700, color: DARK, fontFamily: "'Poppins',sans-serif" }}>₹{(item.price * item.qty).toFixed(2)}</span>
                    </div>
                  </div>
                  <button onClick={() => removeFromCart(item._key)}
                    style={{ background: 'none', border: 'none', color: '#D1D5DB', cursor: 'pointer', alignSelf: 'flex-start', transition: 'color 0.15s', padding: 4, borderRadius: 6 }}
                    onMouseEnter={e => e.currentTarget.style.color = '#DC2626'} onMouseLeave={e => e.currentTarget.style.color = '#D1D5DB'}>
                    <TrashIcon />
                  </button>
                </div>
              ))}
            </div>

            {cart.length > 0 && (
              <div style={{ padding: '16px 20px', borderTop: `1px solid ${BORDER}`, flexShrink: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, paddingBottom: 14, borderBottom: `1px solid ${BORDER}` }}>
                  <span style={{ fontSize: 13, fontWeight: 500, color: GRAY, fontFamily: "'Poppins',sans-serif" }}>Subtotal</span>
                  <span style={{ fontSize: 18, fontWeight: 700, color: DARK, fontFamily: "'Poppins',sans-serif" }}>₹{subtotal.toFixed(2)}</span>
                </div>
                <button onClick={() => { setCartOpen(false); navigate('/checkout'); }}
                  style={{ width: '100%', padding: '13px', background: PRIMARY, color: '#fff', border: 'none', borderRadius: 9, fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: "'Poppins',sans-serif", marginBottom: 8, boxShadow: '0 4px 14px rgba(230,57,70,0.3)', transition: 'background 0.2s' }}
                  onMouseEnter={e => e.target.style.background = '#c0392b'} onMouseLeave={e => e.target.style.background = PRIMARY}>
                  Proceed to Checkout →
                </button>
                <button onClick={() => { setCartOpen(false); navigate('/cart'); }}
                  style={{ width: '100%', padding: '11px', background: 'none', color: DARK, border: `1.5px solid ${BORDER}`, borderRadius: 9, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: "'Poppins',sans-serif", transition: 'border-color 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = PRIMARY} onMouseLeave={e => e.currentTarget.style.borderColor = BORDER}>
                  View Full Cart
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
